import { Draft } from './types';

export const activeCastawayIdsForEpisode = (
  draft: Draft,
  episode: number,
  rosterSize: number,
  scores?: Record<string, any>,
): number[] => {
  if (rosterSize <= 3) return draft.team || [];

  const isEliminatedPrior = (id: number): boolean => {
    if (!scores) return false;
    return Object.entries(scores).some(([epKey, epScores]: [string, any]) => {
      const epNum = Number(String(epKey).replace('episode', ''));
      if (epNum >= episode) return false;
      const s = epScores?.[id] || epScores?.[String(id)];
      return Boolean(s?.votedOut || s?.involuntaryEvacuation || s?.voluntaryExit);
    });
  };

  let candidateIds: number[] = [];
  if (draft.lineupHistory) {
    const eligibleLineups = Object.entries(draft.lineupHistory)
      .map(([lineupEpisode, ids]) => ({ episode: Number(lineupEpisode), ids }))
      .filter(entry => entry.episode <= episode)
      .sort((a, b) => b.episode - a.episode);

    candidateIds = eligibleLineups[0]?.ids || (draft.team || []).slice(0, 3);
  } else {
    candidateIds = (draft.team || []).slice(0, 3);
  }

  return candidateIds.filter(id => !isEliminatedPrior(id));
};

export const scoreDraftByLineup = (
  draft: Draft,
  scores: Record<string, any>,
  scoreCastaway: (castawayId: number, episodeScores: Record<string, any>) => number,
  rosterSize: number,
): number => Object.entries(scores).reduce((total, [episodeKey, episodeScores]) => {
  const episode = Number(String(episodeKey).replace('episode', ''));
  // Episode 1 is a pre-draft tracking episode (no fantasy points scored)
  if (episode === 1) return total;
  const activeIds = activeCastawayIdsForEpisode(draft, episode, rosterSize, scores);
  return total + activeIds.reduce((episodeTotal, castawayId) => episodeTotal + scoreCastaway(castawayId, episodeScores), 0);
}, 0);
